import React, { useState } from "react";
import { BellRing, Check, X } from "lucide-react";
import { memoIcona, memoLabel, isoGiorno } from "./MemoGiorno";
import * as api from "../api";

// Memo di oggi (e non fatti dei giorni scorsi) mostrati sopra la lista all'apertura dell'app
export default function MemoBanner({ memo, onChange, onApri }) {
  const oggi = isoGiorno(new Date());
  const attivi = (memo || []).filter((m) => !m.fatto && m.data <= oggi);
  const [aperto, setAperto] = useState(null); // memo espanso per leggerlo tutto
  if (attivi.length === 0) return null;
  return (
    <div className="memo-banner" data-testid="memo-banner">
      <div className="memo-banner-title" onClick={onApri} role="button" tabIndex={0}>
        <BellRing size={16} strokeWidth={2.5} /> {attivi.length === 1 ? "1 memo per oggi" : `${attivi.length} memo per oggi`}
      </div>
      {attivi.slice(0, 5).map((m) => {
        const Icon = memoIcona(m.tipo);
        return (
          <div
            key={m.id}
            className={`memo-banner-item ${aperto === m.id ? "aperto" : ""}`}
            onClick={() => setAperto(aperto === m.id ? null : m.id)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === "Enter" && setAperto(aperto === m.id ? null : m.id)}
            title={aperto === m.id ? "Riduci" : "Leggi tutto"}
            data-testid={`memo-banner-${m.id}`}
          >
            <Icon size={15} strokeWidth={2.4} />
            <span className="memo-banner-text">
              <b>{memoLabel(m.tipo)}{m.ora ? ` · ${m.ora}` : ""}{m.data < oggi ? ` · dal ${m.data.split("-").reverse().join(".")}` : ""}</b> {m.testo}
              {m.account_label ? <em> · {m.account_label}</em> : null}
            </span>
            <button className="icon-plain" title="Fatto" onClick={(e) => { e.stopPropagation(); api.setMemoFatto(m.id, true).then(onChange); }} data-testid={`memo-banner-fatto-${m.id}`}><Check size={16} /></button>
            <button className="icon-plain" title="Elimina" onClick={(e) => { e.stopPropagation(); api.deleteMemo(m.id).then(onChange); }} data-testid={`memo-banner-del-${m.id}`}><X size={16} /></button>
          </div>
        );
      })}
    </div>
  );
}
